'use client'

import { useTranslations } from 'next-intl'

export const ShowAllButton = ({ number, category }: { number: number; category: string }) => {
  const t = useTranslations('pages.daily-gifts.categories')
  const formatLongNumber = String(new Intl.NumberFormat('en-US').format(number || 0))

  return <>{t('view_all', { number: formatLongNumber, category: category.toLowerCase() })}</>
}
